import React from "react";
import axios from "axios";

import FeedbackBar from "../../feedbackBar/FeedbackBar";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import CustomToolbar from "../../global/CustomToolbar";
import {
  BACK_TO_MENU_TITLE,
  MANAGE_FOLDER_TABLE_HEAD_CELLS
} from "../ManageCompany/constants";

import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";

import { Tooltip } from "@mui/material";

import EditIcon from "@material-ui/icons/Edit";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

import TablePage from "../../global/Table/TablePage";
import SearchableTable from "../../global/Search/SearchableTable";
import TwoStepDelete from "../../global/subcomponents/twoStepDelete/TwoStepDelete";

import withShipment from "../../../withShipment";
import { userInfoSelector } from "../../../redux/selectors/auth";
import { BASE_URL } from "../../global/Server/endpoints";

import './ManageFolder.css'
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";

class ManageFolder extends SearchableTable {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      addingFolder: false,
      folderId: null,
      title: "",
      role: "",
      imageFile: null,
      imagePreview: null,
      dashboardCards: [],
    };
  }

  /* ================= FETCH ================= */
  componentDidMount() {
    this.fetchDashboardFolders();
  }

  fetchDashboardFolders = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.post(
        `${BASE_URL}/dashboardFolder/list`,
        { companyId: this.props.userInfo.company },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.success) {
        this.setState({ dashboardCards: res.data.data });
      } else {
        this.openFeedback("error", res.data.message);
      }
    } catch (err) {
      this.openFeedback("error", "Failed to fetch folders");
    }
  };

  /* ================= FORM ================= */
  handleTitleChange = (e) => {
    const val = e.target.value;
    this.setState({
      title: val,
      role: val.toLowerCase().replace(/ /g, "-"),
    });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    this.setState({
      imageFile: file,
      imagePreview: URL.createObjectURL(file),
    });
  };

  fileToByteArray = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result.split(",")[1];
        const bytes = atob(base64).split("").map(c => c.charCodeAt(0));
        resolve(bytes);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  /* ================= SAVE ================= */
  saveCard = async () => {
    try {
      const token = localStorage.getItem("token");

      const payload = {
        dashboardFolderId: this.state.folderId,
        companyId: this.props.userInfo.company,
        title: this.state.title,
        role: this.state.role,
      };

      if (this.state.imageFile) {
        payload.imageFile = await this.fileToByteArray(this.state.imageFile);
        payload.imageName = this.state.imageFile.name;
      }

      const res = await axios.post(
        `${BASE_URL}/dashboardFolder/save`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.data.success) {
        this.openFeedback("error", res.data.message);
        return;
      }

      await this.fetchDashboardFolders();

      this.openFeedback(
        "success",
        this.state.folderId
          ? "Folder updated successfully!"
          : "Folder created successfully!"
      );

      this.setState({
        addingFolder: false,
        folderId: null,
        title: "",
        role: "",
        imageFile: null,
        imagePreview: null,
      });
    } catch (err) {
      this.openFeedback("error", "Save failed");
    }
  };

  /* ================= HELPERS ================= */
  editFolder = (folder) => {
    this.setState({
      addingFolder: true,
      folderId: folder.dashboardFolderId,
      title: folder.title,
      role: folder.role,
      imagePreview: folder.imageUrl || null,
    });
  };

  openFeedback = (severity, message) => {
    this.setState({
      feedbackBarOpen: true,
      feedbackStatus: severity,
      feedbackMessage: message,
    });
  };

  cancelFolder = () => {
    this.setState({
      addingFolder: false,
      title: "",
      role: "",
      imageFile: null,
      imagePreview: null,
    });
  };

  /* ================= TABLE HEADERS ================= */
  getTableHeaders = () => {
        let headers = []

        MANAGE_FOLDER_TABLE_HEAD_CELLS.forEach((headCell) => {
            headers.push(Layout.columnHead(headCell.label, null, "center"))
        })
        return headers
    }

  /* ================= RENDER ================= */
  render() {
    const headerButtons = !this.state.addingFolder
      ? [
          {
            icon: <AddCircleIcon />,
            handler: () => this.setState({ addingFolder: true }),
            title: "Create Folder",
          },
        ]
      : [
          {
            icon: <KeyboardBackspaceIcon />,
            handler: this.cancelFolder,
            title: "Back",
          },
        ];

    return (
      <>
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={() => this.setState({ feedbackBarOpen: false })}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <ErrorFeedbackBar />

        <CustomToolbar
          title={this.state.addingFolder ? "Create Folder" :"Manage Folder"}
          backTitle={BACK_TO_MENU_TITLE}
          headerButtons={headerButtons}
        />

        {/* ---------- FORM ---------- */}

        {this.state.addingFolder && (
  <div className="manage-folder-form">

    <label>Title</label>
    <input
      className="form-control"
      value={this.state.title}
      onChange={this.handleTitleChange}
    />

    <label>Role</label>
    <input className="form-control" value={this.state.role} readOnly />

    <label>Image</label>
    <input type="file" onChange={this.handleImageChange} />

       {this.state.imagePreview && (
          <img
            src={this.state.imagePreview}
            alt=""
            className="form-image"
          />
        )}


        <Button
          className="save-button"
          variant="contained"
          color="primary"
          onClick={this.saveCard}
        >
          Save Folder
        </Button>
      </div>
    )}


        {/* ---------- TABLE ---------- */}
        {!this.state.addingFolder && (
          <TablePage
            tableName="companyTable"
            tableRows={this.state.dashboardCards}
            tableColumnHeads={this.getTableHeaders()}
            tableRow={(row) => (
              <>
                <TableCell className="table-cell-center">
                  <div style={{ maxWidth: 240, margin: "0 auto",fontWeight:"bold" }}>
                    {row.title}
                  </div>
                </TableCell>

                <TableCell className="table-cell-center">

                    {row.imageUrl ? (
                      <img src={row.imageUrl} alt="" className="table-image" />
                    ) : (
                      "No Image"
                    )}


                </TableCell>


             <TableCell className="table-cell-center" >
                <div className="action-center">
                  <Tooltip title="Edit">
                    <IconButton size="small" onClick={() => this.editFolder(row)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>

                  <TwoStepDelete
                    rowId={row.dashboardFolderId}
                    handleDelete={async (id) => {
                      const token = localStorage.getItem("token");
                      const res = await axios.post(
                        `${BASE_URL}/dashboardFolder/delete`,
                        { dashboardFolderId: id },
                        { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
                      );
                      if (res.data.success) {
                        this.setState({
                          dashboardCards: this.state.dashboardCards.filter(f => f.dashboardFolderId !== id),
                        });
                      }
                    }}
                    deleteId={this.state.deleteId}
                    setDeleteId={(deleteId) => this.setState({ deleteId })}
                  />
                  </div>
                </TableCell>

              </>
            )}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
});

export default withShipment({ mapStateToProps }, ManageFolder);
